<template>
  
<FormKitLazyProvider>
<FormKit
    id="forgot-password"
    name="forgot-password"
    type="form"
    :incomplete-message="$t('Sorry, not all fields are filled out correctly.')"
    :value="data"
    :actions="false"
    @submit="onSubmit"
  >
    <slot name="email">
      <FormKit
        type="email"
        :label="$t('Email address') + ' *'"
        name="email"
        placeholder="email@domain.com"
        validation="required|email"
      />
    </slot>

    <div class="formkit-buttons">
      <slot
        name="actions"
        v-bind="{ requestPasswordResetEmailLoading }"
      >
        <button
          :disabled="requestPasswordResetEmailLoading"
          type="submit"
          class="button"
          :class="{ 'button--loading': requestPasswordResetEmailLoading, 'button--cta': !travelbagsOnly, 'button--shop-flow button--full': travelbagsOnly }"
        >
          <span>{{ $t('Reset password') }}</span>
          <IconLoader
            v-if="requestPasswordResetEmailLoading"
            class="icon icon--loader"
          />
          <IconArrow
            v-if="!travelbagsOnly"
            class="icon icon--right icon--arrow icon--arrow-right"
          />
        </button>
        <AppLink
          class="button button--link button--back"
          to="/account/"
        >
          <span>{{ $t('Back') }}</span>
        </AppLink>
      </slot>
    </div>
  </FormKit>
</FormKitLazyProvider>

</template>

<script lang="ts" setup>
import { FormKitLazyProvider } from '@formkit/vue'
const { requestPasswordResetEmail, requestPasswordResetEmailLoading } = useAccountResetPassword()
const data = ref({ email: '' })
const emit = defineEmits(['success'])
const { public: config } = useRuntimeConfig()

const travelbagsOnly = computed(
  () => config.storeHeader.startsWith('tra'),
)

const onSubmit = async (formData: Parameters<typeof requestPasswordResetEmail>[0]) => {
  const result = await requestPasswordResetEmail(formData)
  emit('success', result)
}
</script>
